<template>
  <div class="form-group custom-form-group">
    <label v-if="displayLabel" :for="id" class="custom-form-group-label">
      {{ label }}
      <template v-if="translated">
        <button
          v-for="locale in availableLocales"
          type="button"
          class="locale-switcher"
          :class="{ 'active': locale.name === currentLocale }"
          :key="locale.name"
          @click="switchLocale(locale.name)">
          {{ locale.title }}
        </button>
      </template>
    </label>
    <span v-if="disclaimer" class="custom-form-group-disclaimer" v-html="disclaimer" />
    <template v-if="translated">
      <textarea
        v-for="locale in availableLocales"
        :key="locale.name"
        v-show="locale.name === currentLocale"
        :id="localeInputId(locale)"
        :name="localeInputName(locale)"
        :value="localeInputValue(locale)"
        :required="required"
        class="form-control custom-input"
        :rows="rows"
        :placeholder="placeholder"
        @input="updateTranslatedValue($event.target.value, locale)"
        @blur="$emit('blur', $event)" />
    </template>
    <template v-else>
      <textarea
        :id="id"
        :name="name"
        :value="value"
        :required="required"
        class="form-control custom-input"
        :rows="rows"
        :placeholder="placeholder"
        @input="updateValue($event.target.value)"
        @blur="$emit('blur', $event)" />
    </template>
  </div>
</template>

<script>
import UIComponentMixin from "../../Mixins/UIComponentMixin";
import { humanize } from "../../helpers";

export default {
  name: "MultilineTextInput",

  mixins: [
    UIComponentMixin
  ],

  props: {
    value: { type: [Array, String, Number, Object] },
    name: { type: String },
    required: { type: Boolean, default: false },
    rows: { type: Number, default: 4 },
    displayLabel: { type: Boolean, default: true },
    customLabel: String,
    disclaimer: String,
    placeholder: String,
    translated: { type: Boolean, default: false }
  },

  computed: {
    label () {
      if (this.$useTranslations) {
        return this.customLabel || this.$t(humanize(this.name, this.$useTranslations));
      } else {
        return this.customLabel || humanize(this.name);
      }
    }
  }
};
</script>
